import React, { ComponentProps } from 'react';
import { Modal } from 'antd';

type CustomProps = {
  onConfirm: () => void;
};

type Props = CustomProps & ComponentProps<typeof Modal>;

export function MembersUpdateLocationsConfirmModal({
  onConfirm,
  ...props
}: Props) {
  return (
    <>
      <Modal
        className="members-update-locations-modal"
        title="Confirm updates?"
        cancelText="Cancel"
        okText="Confirm Update"
        onOk={onConfirm}
        {...props}
      >
        If there are any new users who were just granted unit permissions, they
        will be notified to start using Works.
      </Modal>
      <style jsx>{`
        :global(.members-update-locations-modal .ant-modal-footer) {
          text-align: right;
        }
      `}</style>
    </>
  );
}
